import { FILE_UPLOAD_TYPES, FileUpload, UploadedFile, UploadStatus } from "newui/components/FileUpload";
import { TextAreaWithLabel } from "newui/components/ui/InputWithLabel";
import { UploadFile } from "types/storage.types";
import { ClarificationImpact } from "../../../types/clarification.type";
import { useCallback } from "react";

interface ClarificationSupplierResponseProps {
  clarificationId: number;
  errors: {
    files?: string;
    final_response?: string;
  };
  formData: {
    clarification_impact_id: ClarificationImpact | null;
    files: UploadFile[];
    final_response: string;
  };
  initialFiles?: UploadFile[];
  isViewOnly?: boolean;
  handleInputChange: (field: string, value: any) => void;
}

export const ClarificationSupplierResponse = ({ clarificationId, errors, formData, handleInputChange, initialFiles, isViewOnly }: ClarificationSupplierResponseProps) => {
  const onFilesChanged = useCallback((uploadedFiles: UploadedFile[]) => {
    const files: UploadFile[] = uploadedFiles
      .filter((f) => f.status === UploadStatus.UPLOADED && f.id && f.path)
      .map((f) => ({
        id: f.id!,
        file_name: f.name,
        file_path: f.path!,
        file_size: f.size ?? 0,
      }));
    handleInputChange("files", files);
  }, [handleInputChange]);

  return <>
    {<TextAreaWithLabel
      guideLine={"Provide your final response to the clarification raised by the client. This is not visible to the client until it has been sent to them."}
      label="Your Response"
      name="final_response"
      placeholder="Enter your response to this clarification..."
      required
      value={formData.final_response}
      errorText={errors.final_response}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
        handleInputChange("final_response", e.target.value)
      }
      readOnly={isViewOnly}
    />}
    <FileUpload description="Provide any files to support your response" extraData={{ clarificationId }} multiple onChange={onFilesChanged} supportsHardDelete uploadType={FILE_UPLOAD_TYPES.CLARIFICATION_RESPONSE} initialValue={initialFiles} />
  </>
}